import { getUser } from "@/features/useUser";
import { Business } from "@/types/BusinessInterface";
import { EstateInterface } from "@/types/EstateInterface";

export const isCollaborator = (
  estate: EstateInterface,
  business?: Business | null
): boolean => {
  const user = getUser();

  if (estate.collaboratorIds?.includes(user._id)) {
    return true;
  }

  if (business && estate.collaboratorBusinessIds?.includes(business?._id)) {
    if (business.landownerIds?.includes(user._id)) {
      return true;
    }
  }

  return false;
};
